<template>
  <div class="label-production-container">
    <!-- 顶部标题栏 -->
    <div class="header">
      <h1>标签制作</h1>
    </div>
    <!-- 主内容区 -->
    <div class="main-content">
      <!-- 左侧区域 -->
      <left-panel></left-panel>
      <!-- 中间编辑区域 -->
      <div class="middle-panel">
        <!-- 方案设置 -->
        <div class="scheme-setting">
          <el-form :inline="true" class="scheme-form">
            <el-form-item>
              <el-input v-model="schemeName" placeholder="这里是方案名称" style="width: 200px;margin-right: 30px;"></el-input>
            </el-form-item>
            <el-form-item label="尺寸:">
              <el-input-number v-model="width" :min="1" :max="100" :step="0.1" controls-position="right"
                style="width: 150px;"></el-input-number>
              <span style="margin: 0 12px;">*</span>
              <el-input-number v-model="height" :min="1" :max="100" :step="0.1" controls-position="right"
                style="width: 150px;"></el-input-number>
              <span>cm</span>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="saveScheme">保存方案</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="success" size="mini" @click="loadScheme">加载方案</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="warning" size="mini" @click="printCanvas">打印</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 标签编辑区域 -->
        <div class="middle">
          <div class="editor-container">
            <!-- 标签编辑区域 -->
            <div class="label-editor-container" @mousedown="handleContainerMouseDown" @mouseup="handleContainerMouseUp"
              @mousemove="handleContainerMouseMove">
              <div class="label-editor" ref="labelEditor" :style="{ width: width + 'cm', height: height + 'cm' }">
                <canvas ref="labelCanvas" :width="canvasWidth" :height="canvasHeight" @mousedown="handleCanvasMouseDown"
                  @mouseup="handleCanvasMouseUp" @mousemove="handleCanvasMouseMove"></canvas>
              </div>
              <!-- 尺寸标注 -->
            </div>
            <div class="size-marks">
              <div class="width-mark">{{ height }}cm</div>
              <div class="height-mark">{{ width }}cm</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧工具栏 -->
      <div class="right-panel">
        <!-- 对齐工具 -->
        <div class="panel-section ">
          <div class="tool-buttons">

            <div class="item" @click="alignHorizontalCenter" title="水平居中">
              <img src="@/assets/labelProduction/center.png" />
            </div>
            <div class="item" @click="alignVerticalCenter" title="垂直居中">
              <img src="@/assets/labelProduction/line.png" />
            </div>
            <div class="item" @click="alignPerfectCenter" title="完全居中">
              <img src="@/assets/labelProduction/line-center.png" />
            </div>
            <div class="item" title="删除" @click="deleteSelectedElement">
              <img src="@/assets/labelProduction/delete.png" />
            </div>
          </div>
        </div>
        <!-- 工具 -->
        <div class="panel-section">
          <h3>工具</h3>
          <div class="tool-buttons">
            <div class="item" @click="addText" title="添加文本">
              <img src="@/assets/labelProduction/text.png" />
            </div>
            <div class="item" @click="showBarcodeDialog" title="添加条形码">
              <img src="@/assets/labelProduction/yiweima.png" />
            </div>
            <div class="item" @click="showQrCodeDialog" title="添加二维码">
              <img src="@/assets/labelProduction/erweima.png" />
            </div>
            <div class="item" @click="showImageDialog" title="添加图片">
              <img src="@/assets/labelProduction/pic.png" />
            </div>
          </div>
        </div>
        <!-- 重做按钮 -->
        <div class="resetTemplate">
          <el-button type="warning" class="tool-action-btn" @click="resetTemplate" title="重做">重做
          </el-button>
        </div>
        <!-- 一维码 -->
        <barcode-dialog :visible.sync="barcodeDialogVisible" :barcode-form="barcodeForm"
          @generate="generateBarcode"></barcode-dialog>
        <!-- 二维码 -->
        <qr-code-dialog :visible.sync="qrCodeDialogVisible" :qr-code-form="qrCodeForm"
          @generate="generateQrCode"></qr-code-dialog>
        <!-- 图片 -->
        <image-upload-dialog :visible.sync="imageDialogVisible" :image-file="imageFile" :image-preview="imagePreview"
          :image-size="imageSize" @upload="handleImageUpload" @add="addImage" @update-file="(file) => imageFile = file"
          @update-preview="(preview) => imagePreview = preview" @update-size="(size) => imageSize = size">
        </image-upload-dialog>
        <!-- 文字设置 -->
        <div class="panel-section">
          <h3>文字</h3>
          <div class="text-settings">
            <div class="setting-item">
              <el-input v-model="selectedText" placeholder="请输入文本内容" @input="updateSelectedText"
                :disabled="!selectedElementId"></el-input>
            </div>
            <div class="setting-item">
              <el-select v-model="currentFont" placeholder="这里是字体名称" style="width: 100%;" @change="updateElementStyle"
                :disabled="!selectedElementId">
                <el-option v-for="item in fontOptions" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
            <div class="setting-item">
              <!-- 字重 -->
              <div class="item">
                <el-select v-model="currentFontWeight" placeholder="字重" style="width: 100%;"
                  @change="updateElementStyle" :disabled="!selectedElementId">
                  <el-option v-for="item in fontWeightOptions" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </div>
              <!--字号  -->
              <div class="item" style="margin-left: 6px;">
                <el-select v-model="currentFontSize" placeholder="字号" style="width: 100%;" @change="updateElementStyle"
                  :disabled="!selectedElementId">
                  <el-option v-for="item in fontSizeOptions" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JsBarcode from 'jsbarcode';
import QRCode from 'qrcode';
import LeftPanel from './components/LeftPanel.vue';
import BarcodeDialog from './components/BarcodeDialog.vue';
import QrCodeDialog from './components/QrCodeDialog.vue';
import ImageUploadDialog from './components/ImageUploadDialog.vue';
import { fontOptions, fontWeightOptions, fontSizeOptions, barcodeTypes } from './optionData.js';

export default {
  name: 'LabelProduction',
  components: {
    LeftPanel,
    BarcodeDialog,
    QrCodeDialog,
    ImageUploadDialog
  },
  data() {
    return {
      fontOptions, fontWeightOptions, fontSizeOptions, barcodeTypes,
      width: 10,
      height: 15,

      // Canvas相关
      canvasWidth: 0,
      canvasHeight: 0,
      ctx: null,
      canvasElements: [],
      currentElement: null,
      isDragging: false,
      isResizing: false,
      dragStartPos: { x: 0, y: 0 },
      resizeHandle: null,
      // 文字样式
      currentFont: '',
      currentFontWeight: '',
      currentFontSize: '',
      // 选中状态
      selectedElementId: null,
      selectedText: '',
      // 条形码生成
      barcodeDialogVisible: false,
      barcodeForm: {
        content: '',
        width: 200,
        height: 80,
        type: 'CODE128',
        fontSize: 12
      },

      // 条形码缓存，避免重复生成导致闪烁
      barcodeCache: {},
      // 二维码生成
      qrCodeDialogVisible: false,
      qrCodeForm: {
        content: '',
        size: 150
      },
      // 二维码缓存
      qrCodeCache: {},
      // 图片上传
      imageDialogVisible: false,
      imageFile: null,
      imagePreview: '',
      imageSize: 100,
      // 图片缓存
      imageCache: {},
      // 方案管理
      schemeName: '',
      savedSchemes: []
    };
  },
  mounted() {
    this.initCanvas();
    this.updateCanvasSize();
    this.drawCanvas();
    // 监听窗口大小变化
    window.addEventListener('resize', this.updateCanvasSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateCanvasSize);
  },
  watch: {
    width() {
      // Wait for DOM to update before resizing canvas
      this.$nextTick(() => {
        this.updateCanvasSize();
        this.drawCanvas();
      });
    },
    height() {
      // Wait for DOM to update before resizing canvas
      this.$nextTick(() => {
        this.updateCanvasSize();
        this.drawCanvas();
      });
    },
    currentFont() {
      this.updateElementStyle();
      this.drawCanvas();
    },
    currentFontWeight() {
      this.updateElementStyle();
      this.drawCanvas();
    },
    currentFontSize() {
      this.updateElementStyle();
      this.drawCanvas();
    }
  },
  methods: {
    // 初始化Canvas
    initCanvas() {
      const canvas = this.$refs.labelCanvas;
      this.ctx = canvas.getContext('2d');
      // 添加默认元素
      // this.addCanvasElement({
      //   type: 'text', 
      //   text: 'MADE IN CHINA', 
      //   x: 150, 
      //   y: 100,
      //   font: this.currentFont,
      //   fontWeight: this.currentFontWeight,
      //   fontSize: this.currentFontSize
      // });
      // this.addCanvasElement({ type: 'barcode', value: this.barcodeValue, x: 100, y: 50, width: 200, height: 80 });
    },

    // 更新Canvas尺寸
    updateCanvasSize() {
      const editor = this.$refs.labelEditor;
      const rect = editor.getBoundingClientRect();
      this.canvasWidth = rect.width;
      this.canvasHeight = rect.height;
    },

    // 绘制Canvas
    drawCanvas() {
      if (!this.ctx) return;

      // 强制清空Canvas，确保完全重置
      this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);

      // 绘制白色背景
      this.ctx.fillStyle = '#ffffff';
      this.ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);

      // 遍历所有元素并绘制
      for (let i = 0; i < this.canvasElements.length; i++) {
        const element = this.canvasElements[i];
        this.drawElement(element);
      }

      // 确保所有元素都被绘制，添加一个额外的绘制调用
      this.$nextTick(() => {
        if (this.ctx) {
          for (let i = 0; i < this.canvasElements.length; i++) {
            const element = this.canvasElements[i];
            this.drawElement(element);
          }
        }
      });
    },

    // 绘制单个元素
    drawElement(element) {
      if (!this.ctx) return;

      // 保存当前状态
      this.ctx.save();

      // 设置元素样式
      this.ctx.fillStyle = element.color || '#000000';
      this.ctx.strokeStyle = element.borderColor || '#000000';
      this.ctx.lineWidth = element.borderWidth || 1;

      // 根据元素类型绘制
      switch (element.type) {
        case 'text':
          // 确保所有必要的文字属性都存在
          const fontWeight = element.fontWeight || this.currentFontWeight;
          const fontSize = element.fontSize || this.currentFontSize;
          const font = element.font || this.currentFont;
          const text = element.text || '';

          // 设置字体和样式
          this.ctx.font = `${fontWeight} ${fontSize}px ${font}`;
          this.ctx.textAlign = 'center';
          this.ctx.textBaseline = 'middle';
          this.ctx.fillStyle = element.color || '#000000';

          // 确保文字在元素的宽高中居中显示
          const textX = element.x + element.width / 2;
          const textY = element.y + element.height / 2;

          // 绘制文字
          this.ctx.fillText(text, textX, textY);
          break;

        case 'barcode':
          // 生成缓存键，包含条形码类型和字体大小
          const cacheKey = `${element.value}_${element.width}_${element.height}_${element.barcodeType || 'CODE128'}_${element.fontSize || 12}`;

          if (this.barcodeCache[cacheKey]) {
            // 使用缓存的Image对象绘制
            this.ctx.drawImage(this.barcodeCache[cacheKey], element.x, element.y, element.width, element.height);
          } else {
            // 生成新的条形码并缓存
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('width', element.width);
            svg.setAttribute('height', element.height);

            // 生成条形码，使用自定义类型和字体大小
            JsBarcode(svg, element.value, {
              format: element.barcodeType || 'CODE128',
              width: 2,
              height: element.height - 20,
              displayValue: true,
              fontSize: element.fontSize || 12,
              margin: 10
            });

            // 将SVG转换为Canvas
            const svgData = new XMLSerializer().serializeToString(svg);
            const img = new Image();
            img.onload = () => {
              // 缓存Image对象
              this.barcodeCache[cacheKey] = img;
              // 只有当元素仍然存在且可见时才绘制
              const elementExists = this.canvasElements.some(el => el.id === element.id);
              if (elementExists) {
                this.ctx.drawImage(img, element.x, element.y, element.width, element.height);
              }
            };
            img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)));

            // 绘制一个占位矩形，避免闪烁
            this.ctx.fillStyle = '#ffffff';
            this.ctx.fillRect(element.x, element.y, element.width, element.height);
          }
          break;

        case 'qrcode':
          // 生成缓存键
          const qrCacheKey = `${element.value}_${element.width}_${element.height}`;

          if (this.qrCodeCache[qrCacheKey]) {
            // 使用缓存的Image对象绘制
            this.ctx.drawImage(this.qrCodeCache[qrCacheKey], element.x, element.y, element.width, element.height);
          } else {
            // 生成新的二维码并缓存
            // 绘制一个占位矩形，避免闪烁
            this.ctx.fillStyle = '#ffffff';
            this.ctx.fillRect(element.x, element.y, element.width, element.height);

            // 使用QRCode库生成二维码
            QRCode.toDataURL(element.value, {
              width: element.width,
              margin: 2,
              color: {
                dark: '#000000',
                light: '#ffffff'
              }
            })
              .then(url => {
                const img = new Image();
                img.onload = () => {
                  // 缓存Image对象
                  this.qrCodeCache[qrCacheKey] = img;
                  // 只有当元素仍然存在时才绘制
                  const elementExists = this.canvasElements.some(el => el.id === element.id);
                  if (elementExists) {
                    this.ctx.drawImage(img, element.x, element.y, element.width, element.height);
                  }
                };
                img.src = url;
              })
              .catch(err => {
                console.error('Error generating QR code:', err);
                this.$message.error('生成二维码失败');
              });
          }
          break;

        case 'image':
          // 生成缓存键
          const imageCacheKey = `${element.value}_${element.width}_${element.height}`;

          if (this.imageCache[imageCacheKey]) {
            // 使用缓存的Image对象绘制
            this.ctx.drawImage(this.imageCache[imageCacheKey], element.x, element.y, element.width, element.height);
          } else {
            // 生成新的图片并缓存
            // 绘制一个占位矩形，避免闪烁
            this.ctx.fillStyle = '#ffffff';
            this.ctx.fillRect(element.x, element.y, element.width, element.height);

            const img = new Image();
            img.onload = () => {
              // 缓存Image对象
              this.imageCache[imageCacheKey] = img;
              // 只有当元素仍然存在时才绘制
              const elementExists = this.canvasElements.some(el => el.id === element.id);
              if (elementExists) {
                this.ctx.drawImage(img, element.x, element.y, element.width, element.height);
              }
            };
            img.src = element.value;
          }
          break;
      }

      // 如果元素被选中，绘制选中框和调整手柄
      if (element.id === this.selectedElementId) {
        this.drawSelection(element);
      }

      // 恢复状态
      this.ctx.restore();
    },

    // 绘制选中框
    drawSelection(element) {
      if (!this.ctx) return;

      // 调整padding为2px
      const padding = 2;

      // 绘制选中框
      this.ctx.strokeStyle = '#673ab7';
      this.ctx.lineWidth = 2;
      this.ctx.setLineDash([5, 5]);
      this.ctx.strokeRect(element.x - padding, element.y - padding, element.width + padding * 2, element.height + padding * 2);
      this.ctx.setLineDash([]);

      // 绘制调整手柄
      const handleSize = 8;
      const handles = [
        { x: element.x - padding, y: element.y - padding }, // 左上
        { x: element.x + element.width / 2, y: element.y - padding }, // 中上
        { x: element.x + element.width + padding, y: element.y - padding }, // 右上
        { x: element.x + element.width + padding, y: element.y + element.height / 2 }, // 右中
        { x: element.x + element.width + padding, y: element.y + element.height + padding }, // 右下
        { x: element.x + element.width / 2, y: element.y + element.height + padding }, // 中下
        { x: element.x - padding, y: element.y + element.height + padding }, // 左下
        { x: element.x - padding, y: element.y + element.height / 2 } // 左中
      ];

      this.ctx.fillStyle = '#673ab7';
      handles.forEach(handle => {
        this.ctx.fillRect(handle.x - handleSize / 2, handle.y - handleSize / 2, handleSize, handleSize);
      });
    },

    // 添加Canvas元素
    addCanvasElement(elementData) {
      // 确保文本元素有text属性
      const defaultText = elementData.type === 'text' ? elementData.text || '新文本' : undefined;

      const element = {
        id: Date.now().toString(),
        x: 100,
        y: 100,
        width: 100,
        height: 50,
        color: '#000000',
        fontSize: this.currentFontSize,
        fontWeight: this.currentFontWeight,
        font: this.currentFont,
        ...elementData,
        // 确保文本元素始终有text属性
        ...(defaultText !== undefined && { text: defaultText })
      };

      this.canvasElements.push(element);
      this.selectedElementId = element.id;
      this.drawCanvas();

      return element;
    },

    // 更新元素样式
    updateElementStyle() {
      const selectedElement = this.canvasElements.find(el => el.id === this.selectedElementId);
      if (selectedElement) {
        selectedElement.fontSize = this.currentFontSize;
        selectedElement.fontWeight = this.currentFontWeight;
        selectedElement.font = this.currentFont;
        this.drawCanvas();
      }
    },

    // 更新选中元素的文本内容
    updateSelectedText() {
      const selectedElement = this.canvasElements.find(el => el.id === this.selectedElementId);
      if (selectedElement && selectedElement.type === 'text') {
        selectedElement.text = this.selectedText;
        this.drawCanvas();
      }
    },

    // 处理Canvas鼠标按下事件
    handleCanvasMouseDown(e) {
      const rect = this.$refs.labelCanvas.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;

      // 检查是否点击在调整手柄上
      let clickedHandle = null;
      this.canvasElements.forEach(element => {
        if (element.id === this.selectedElementId) {
          const handleSize = 8;
          const padding = 2;
          const handles = [
            { x: element.x - padding, y: element.y - padding, type: 'nw' },
            { x: element.x + element.width / 2, y: element.y - padding, type: 'n' },
            { x: element.x + element.width + padding, y: element.y - padding, type: 'ne' },
            { x: element.x + element.width + padding, y: element.y + element.height / 2, type: 'e' },
            { x: element.x + element.width + padding, y: element.y + element.height + padding, type: 'se' },
            { x: element.x + element.width / 2, y: element.y + element.height + padding, type: 's' },
            { x: element.x - padding, y: element.y + element.height + padding, type: 'sw' },
            { x: element.x - padding, y: element.y + element.height / 2, type: 'w' }
          ];

          handles.forEach(handle => {
            if (Math.abs(mouseX - handle.x) <= handleSize && Math.abs(mouseY - handle.y) <= handleSize) {
              clickedHandle = handle.type;
            }
          });
        }
      });

      if (clickedHandle) {
        // 调整大小
        this.isResizing = true;
        this.resizeHandle = clickedHandle;
        this.dragStartPos = { x: mouseX, y: mouseY };
      } else {
        // 检查是否点击在元素上
        let clickedElement = null;
        for (let i = this.canvasElements.length - 1; i >= 0; i--) {
          const element = this.canvasElements[i];
          if (mouseX >= element.x && mouseX <= element.x + element.width &&
            mouseY >= element.y && mouseY <= element.y + element.height) {
            clickedElement = element;
            break;
          }
        }

        if (clickedElement) {
          // 拖动元素
          this.isDragging = true;
          this.currentElement = clickedElement;
          this.selectedElementId = clickedElement.id;
          this.dragStartPos = { x: mouseX - clickedElement.x, y: mouseY - clickedElement.y };

          // 更新选中元素的属性到右侧面板
          if (clickedElement.type === 'text') {
            // 更新文本内容
            this.selectedText = clickedElement.text;
            // 更新字体属性
            this.currentFont = clickedElement.font || this.currentFont;
            this.currentFontWeight = clickedElement.fontWeight || this.currentFontWeight;
            this.currentFontSize = clickedElement.fontSize || this.currentFontSize;
          } else {
            this.selectedText = '';
          }

          // 选中元素后居中显示
          this.centerElement(clickedElement);
        } else {
          // 取消选择
          this.selectedElementId = null;
          this.selectedText = '';
          this.drawCanvas();
        }
      }

      this.drawCanvas();
    },
    // 处理Canvas鼠标移动事件
    handleCanvasMouseMove(e) {
      if (!this.isDragging && !this.isResizing) return;

      const rect = this.$refs.labelCanvas.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;

      if (this.isDragging && this.currentElement) {
        // 拖动元素
        this.currentElement.x = mouseX - this.dragStartPos.x;
        this.currentElement.y = mouseY - this.dragStartPos.y;
      } else if (this.isResizing && this.selectedElementId) {
        // 调整大小
        const element = this.canvasElements.find(el => el.id === this.selectedElementId);
        if (element) {
          const deltaX = mouseX - this.dragStartPos.x;
          const deltaY = mouseY - this.dragStartPos.y;

          switch (this.resizeHandle) {
            case 'nw':
              element.x += deltaX;
              element.y += deltaY;
              element.width -= deltaX;
              element.height -= deltaY;
              break;
            case 'n':
              element.y += deltaY;
              element.height -= deltaY;
              break;
            case 'ne':
              element.y += deltaY;
              element.width += deltaX;
              element.height -= deltaY;
              break;
            case 'e':
              element.width += deltaX;
              break;
            case 'se':
              element.width += deltaX;
              element.height += deltaY;
              break;
            case 's':
              element.height += deltaY;
              break;
            case 'sw':
              element.x += deltaX;
              element.width -= deltaX;
              element.height += deltaY;
              break;
            case 'w':
              element.x += deltaX;
              element.width -= deltaX;
              break;
          }

          // 确保元素大小不为负数
          element.width = Math.max(10, element.width);
          element.height = Math.max(10, element.height);

          this.dragStartPos = { x: mouseX, y: mouseY };
        }
      }

      this.drawCanvas();
    },

    // 处理Canvas鼠标释放事件
    handleCanvasMouseUp() {
      this.isDragging = false;
      this.isResizing = false;
      this.currentElement = null;
      this.resizeHandle = null;
    },

    // 处理容器鼠标事件
    handleContainerMouseDown() { },
    handleContainerMouseUp() {
      this.handleCanvasMouseUp();
    },
    handleContainerMouseMove(e) {
      if (this.isDragging || this.isResizing) {
        this.handleCanvasMouseMove(e);
      }
    },

    // 添加文本
    addText() {
      this.addCanvasElement({
        type: 'text',
        text: '新文本',
        x: 100,
        y: 100,
        width: 100,
        height: 30,
        font: this.currentFont,
        fontWeight: this.currentFontWeight,
        fontSize: this.currentFontSize
      });
    },
    // 显示条形码生成弹框
    showBarcodeDialog() {
      this.barcodeDialogVisible = true;
    },
    // 生成条形码
    generateBarcode() {
      if (!this.barcodeForm.content) {
        this.$message.warning('请输入条形码内容');
        return;
      }

      // 添加条形码元素到Canvas
      this.addCanvasElement({
        type: 'barcode',
        value: this.barcodeForm.content,
        x: (this.canvasWidth - this.barcodeForm.width) / 2,
        y: (this.canvasHeight - this.barcodeForm.height) / 2,
        width: this.barcodeForm.width,
        height: this.barcodeForm.height,
        barcodeType: this.barcodeForm.type,
        fontSize: this.barcodeForm.fontSize
      });

      // 关闭弹框
      this.barcodeDialogVisible = false;
      this.barcodeForm.content = '';
    },

    // 显示二维码生成弹框
    showQrCodeDialog() {
      this.qrCodeDialogVisible = true;
    },

    // 生成二维码
    generateQrCode() {
      if (!this.qrCodeForm.content) {
        this.$message.warning('请输入二维码内容');
        return;
      }

      // 添加二维码元素到Canvas
      this.addCanvasElement({
        type: 'qrcode',
        value: this.qrCodeForm.content,
        x: (this.canvasWidth - this.qrCodeForm.size) / 2,
        y: (this.canvasHeight - this.qrCodeForm.size) / 2,
        width: this.qrCodeForm.size,
        height: this.qrCodeForm.size
      });

      // 关闭弹框
      this.qrCodeDialogVisible = false;
      this.qrCodeForm.content = '';
    },

    // 显示图片上传弹框
    showImageDialog() {
      this.imageDialogVisible = true;
      this.imageFile = null;
      this.imagePreview = '';
      this.imageSize = 100;
    },

    // 处理图片上传
    handleImageUpload(file) {
      const isImage = file.raw.type.startsWith('image/');
      const isLt2M = file.raw.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error('只能上传图片文件');
        return false;
      }

      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB');
        return false;
      }

      // 读取图片文件并生成预览
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imagePreview = e.target.result;
      };
      reader.readAsDataURL(file.raw);

      this.imageFile = file.raw;
      return true;
    },

    // 添加图片到Canvas
    addImage() {
      if (!this.imageFile) {
        this.$message.warning('请选择图片');
        return;
      }

      // 添加图片元素到Canvas
      this.addCanvasElement({
        type: 'image',
        value: this.imagePreview,
        x: (this.canvasWidth - this.imageSize) / 2,
        y: (this.canvasHeight - this.imageSize) / 2,
        width: this.imageSize,
        height: this.imageSize
      });

      // 关闭弹框
      this.imageDialogVisible = false;
      this.imageFile = null;
      this.imagePreview = '';
      this.imageSize = 100;
    },

    // 删除选中元素
    deleteSelectedElement() {
      if (this.selectedElementId) {
        this.canvasElements = this.canvasElements.filter(el => el.id !== this.selectedElementId);
        this.selectedElementId = null;
        this.drawCanvas();
      }
    },

    // 居中显示元素
    centerElement(element) {
      // 这里只标记选中状态，实际居中显示通过绘制时的视觉效果体现
      // 如果需要真正居中位置，可以使用以下代码：
      // element.x = (this.canvasWidth - element.width) / 2;
      // element.y = (this.canvasHeight - element.height) / 2;
      // this.drawCanvas();
    },

    // 保存方案
    saveScheme() {
      if (!this.schemeName) {
        this.$message.warning('请输入方案名称');
        return;
      }

      // 创建方案数据，确保文本元素的text属性存在
      const canvas_data = this.canvasElements.map(element => {
        if (element.type === 'text' && !element.text) {
          return { ...element, text: '' };
        }
        return element;
      });

      const scheme = {
        name: this.schemeName,
        width: this.width,
        height: this.height,
        canvas_data: JSON.parse(JSON.stringify(canvas_data)),
        timestamp: Date.now()
      };

      // 保存到localStorage
      let savedSchemes = JSON.parse(localStorage.getItem('labelSchemes') || '[]');

      // 检查是否已存在同名方案
      const existingIndex = savedSchemes.findIndex(s => s.name === this.schemeName);
      if (existingIndex > -1) {
        // 更新现有方案
        savedSchemes[existingIndex] = scheme;
      } else {
        // 添加新方案
        savedSchemes.push(scheme);
      }

      // 保存到localStorage
      localStorage.setItem('labelSchemes', JSON.stringify(savedSchemes));
      this.savedSchemes = savedSchemes;

      this.$message.success('方案保存成功');
    },

    // 加载方案
    loadScheme() {
      // 这里可以实现一个方案选择对话框
      // 为了简化，这里直接从localStorage加载第一个方案
      const savedSchemes = JSON.parse(localStorage.getItem('labelSchemes') || '[]');

      if (savedSchemes.length === 0) {
        this.$message.warning('没有找到保存的方案');
        return;
      }

      // 显示方案选择对话框
      this.$prompt('请输入要加载的方案名称', '加载方案', {
        confirmButtonText: '加载',
        cancelButtonText: '取消',
        inputValue: savedSchemes[0].name
      }).then(({ value }) => {
        const scheme = savedSchemes.find(s => s.name === value);
        if (scheme) {
          // 恢复方案数据
          this.schemeName = scheme.name;

          // 先清空元素并重置画布
          this.canvasElements = [];
          this.drawCanvas();

          // 再设置新的宽度和高度，触发DOM更新
          this.width = scheme.width;
          this.height = scheme.height;

          // 使用setTimeout等待DOM完全更新，包括布局计算
          setTimeout(() => {
            // 更新Canvas尺寸（多次调用确保获取正确尺寸）
            this.updateCanvasSize();
            this.updateCanvasSize();

            // 恢复元素
            this.canvasElements = JSON.parse(JSON.stringify(scheme.canvas_data));
            console.log(JSON.parse(JSON.stringify(scheme.canvas_data)));

            // 重绘Canvas（多次调用确保所有元素都被绘制）
            this.drawCanvas();
            this.drawCanvas();

            // 再次调用drawCanvas确保所有元素都被绘制
            setTimeout(() => {
              this.drawCanvas();
            }, 200);
          }, 300);

          this.$message.success('方案加载成功');
        } else {
          this.$message.error('未找到指定方案');
        }
      }).catch(() => {
        // 取消加载
      });
    },

    // 打印Canvas
    printCanvas() {
      if (!this.$refs.labelCanvas) return;

      // 创建一个新的Canvas用于打印
      const printCanvas = document.createElement('canvas');
      printCanvas.width = this.canvasWidth;
      printCanvas.height = this.canvasHeight;
      const printCtx = printCanvas.getContext('2d');

      // 绘制背景
      printCtx.fillStyle = '#ffffff';
      printCtx.fillRect(0, 0, printCanvas.width, printCanvas.height);

      // 复制当前Canvas内容
      printCtx.drawImage(this.$refs.labelCanvas, 0, 0);

      // 创建打印窗口
      const printWindow = window.open('', '', 'width=800,height=600');
      printWindow.document.write('<html><head><title>打印标签</title></head><body style="margin: 0; padding: 20px; text-align: center;">');
      printWindow.document.write('<img src="' + printCanvas.toDataURL() + '" style="max-width: 100%; max-height: 90vh;" />');
      printWindow.document.write('</body></html>');
      printWindow.document.close();

      // 延迟打印，确保内容加载完成
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    },

    // 水平居中对齐
    alignHorizontalCenter() {
      const selectedElement = this.canvasElements.find(el => el.id === this.selectedElementId);
      if (selectedElement) {
        // 计算水平居中位置
        selectedElement.x = (this.canvasWidth - selectedElement.width) / 2;
        this.drawCanvas();
      }
    },

    // 完全居中对齐
    alignPerfectCenter() {
      const selectedElement = this.canvasElements.find(el => el.id === this.selectedElementId);
      if (selectedElement) {
        // 计算完全居中位置
        selectedElement.x = (this.canvasWidth - selectedElement.width) / 2;
        selectedElement.y = (this.canvasHeight - selectedElement.height) / 2;
        this.drawCanvas();
      }
    },

    // 垂直居中对齐
    alignVerticalCenter() {
      const selectedElement = this.canvasElements.find(el => el.id === this.selectedElementId);
      if (selectedElement) {
        // 计算垂直居中位置
        selectedElement.y = (this.canvasHeight - selectedElement.height) / 2;
        this.drawCanvas();
      }
    },

    // 重置模板（重做）
    resetTemplate() {
      // 清空画布元素
      this.canvasElements = [];
      // 重置选中状态
      this.selectedElementId = null;
      // 清空文本内容
      this.selectedText = '';
      // 重绘画布
      this.drawCanvas();
    }
  }
};
</script>

<style lang="scss" scoped>
.label-production-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;
  font-size: 12px;

  .header {
    background: linear-gradient(90deg, #9658F4 0%, #5882F4 100%);
    color: white;
    height: 72px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    line-height: 72px;
    padding-left: 24px;

    h1 {
      margin: 0;
      font-size: 24px;
      font-weight: 500;
    }
  }

  .main-content {
    display: flex;
    flex: 1;
    overflow: hidden;

    .middle-panel {
      flex: 1;

      overflow-y: auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    .right-panel {
      width: 206px;
      background-color: white;
      border-left: 1px solid #e4e7ed;
      padding: 20px;
      overflow-y: auto;

      h3 {
        font-size: 16px;
        padding: 20px 0 15px;
        border-top: 1px solid #e4e7ed;
        margin-top: 20px;
      }
    }
  }
}

/* 方案设置 */
.scheme-setting {
  margin: 30px auto 0px;

  .scheme-form {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .el-form-item {
      margin-right: 12px;
      margin-bottom: 0;

      &__label {
        font-size: 11px;
        padding-right: 6px;
      }
    }

    .el-input-number {
      margin-right: 4px;
      width: 70px;
    }

    .el-input {
      width: 120px;

      .el-input__inner {
        font-size: 11px;
        height: 28px;
      }
    }

    span {
      color: #606266;

    }
  }
}

/* 标签编辑器 */
.middle {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .editor-container {
    padding: 50px;
    border: 1px dashed #999;
    position: relative;
    margin: 60px 0;

    .label-editor-container {
      cursor: default;

      .label-editor {
        background-color: white;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        // min-width: 300px;
        // min-height: 200px;
        overflow: hidden;

        canvas {
          width: 100%;
          height: 100%;
          cursor: default;
          display: block;
        }

        &.resizing-nw,
        &.resizing-ne,
        &.resizing-sw,
        &.resizing-se {
          cursor: nwse-resize;
        }

        &.resizing-n,
        &.resizing-s {
          cursor: ns-resize;
        }

        &.resizing-e,
        &.resizing-w {
          cursor: ew-resize;
        }

        &.dragging {
          cursor: move;
        }
      }




    }

    .size-marks {
      font-size: 14px;
      color: #666666;

      .width-mark {
        position: absolute;
        top: 50%;
        left: 8px;
        transform: translateY(-50%);
      }

      .height-mark {
        position: absolute;
        bottom: 15px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}



/* 确保元素在选中时视觉上更突出 */
.scheme-form .el-button--primary {
  background: linear-gradient(90deg, #9658F4 0%, #5882F4 100%);
  border: none;
  margin-left: 30px;
  height: 40px;
}

.scheme-form .el-button--primary:hover,
.scheme-form .el-button--primary:focus {
  background-color: #7c4dff;
  border-color: #7c4dff;
}



/* 工具按钮 */
.tool-buttons {
  display: flex;

  .item {
    // width: 24px;
    flex: 1;
    height: 24px;
    display: flex;
    margin-right: 12px;
    border-radius: 4px;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &:hover {
      background: #F0F0F0
    }

    img {
      width: 16px;
      height: 16px;
    }
  }

  .tool-action-btn {
    width: 100%;
  }
}

/* 对齐工具 */
.align-buttons {


  .el-button-group {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .el-button {
      flex: 1;
      margin-right: 4px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}

/* 文字设置 */
.text-settings {
  display: flex;
  flex-direction: column;

  .setting-item {
    margin-bottom: 12px;
    display: flex;
  }
}

.resetTemplate {
  display: flex;
  margin-top: 20px;

  .el-button {
    width: 100%;
    height: 38px;
    background-color: #9658F4;
    border-color: #9658F4;
  }
}

/* 表单样式 */
.el-form-item__label {
  font-size: 11px;
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;

  &:hover {
    background: #a8a8a8;
  }
}
</style>